// ============================================================
// csv.js
// ------------------------------------------------------------
// ส่งออกไฟล์ CSV ที่ Excel ภาษาไทยเปิดได้
//
// ข้อกำหนดของไฟล์ (สเปกหน้ากระทบยอด GL ข้อ 11.4)
//   - UTF-8 with BOM (﻿ นำหน้า) ไม่งั้นภาษาไทยเป็นตัวยึกยือใน Excel
//   - คั่นด้วย , / ค่าที่มี , " หรือขึ้นบรรทัดใหม่ ให้ครอบด้วย " และ escape " เป็น ""
//   - ตัวเลขทศนิยม 2 ตำแหน่ง ไม่มีตัวคั่นหลักพัน (ให้ Excel มองเป็นตัวเลข)
//   - วันที่ dd/MM/yyyy พ.ศ.
//
// ระบบเดิมส่งออกเป็น Excel ด้วยการขูดตาราง DOM (react-export-table-to-excel)
// ซึ่งใช้กับหน้าที่ตารางซ้าย-ขวาไม่ตรงกับไฟล์ผลลัพธ์ไม่ได้ จึงประกอบไฟล์เองที่นี่
// ============================================================

import { format_date } from "./format.js";

// ค่าตัวเลขสำหรับ CSV — 2 ตำแหน่ง ไม่มีคอมม่าคั่นหลักพัน
export const csvNumber = (value) => (Number(value) || 0).toFixed(2);

// วันที่สำหรับ CSV — dd/mm/yyyy พ.ศ. (ค่าว่างคืนสตริงว่าง)
export const csvDate = (value) => (value ? format_date(value, "dd/mm/yyyy") : "");

// ครอบ/escape ค่า 1 ช่องตามมาตรฐาน RFC 4180
const escapeCell = (value) => {
  const text = value === null || value === undefined ? "" : String(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// ประกอบเนื้อไฟล์ CSV จาก header + rows (rows = array ของ array)
// แยกออกมาเพื่อให้เทสต์/นำไปต่อท่อ streaming ได้โดยไม่ต้องยุ่งกับ DOM
export const buildCsv = (headers, rows) => [headers, ...rows].map((row) => row.map(escapeCell).join(",")).join("\r\n");

// ดาวน์โหลดไฟล์ CSV
//   filename : ชื่อไฟล์ (เติม .csv ให้ถ้าไม่ได้ใส่มา)
//   headers  : array ของหัวคอลัมน์
//   rows     : array ของแถว (แต่ละแถวเป็น array ตามลำดับ headers)
// ไฟล์ใหญ่ (หลายพันแถว) ประกอบเป็นก้อนเดียวแล้วปล่อยผ่าน Blob — เบราว์เซอร์เขียนลงดิสก์เอง ไม่ค้าง
export const exportCsv = (filename, headers, rows) => {
  const blob = new Blob(["﻿", buildCsv(headers, rows)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// ท้ายชื่อไฟล์ตามสเปก — 20260814-1147
export const csvStamp = (date = new Date()) => {
  const p = (n) => String(n).padStart(2, "0");
  return `${date.getFullYear()}${p(date.getMonth() + 1)}${p(date.getDate())}-${p(date.getHours())}${p(date.getMinutes())}`;
};
